export default __webpack_public_path__ + "02f51bb2ff54ad5b5d998e97baa84285.svg";